export default "__VITE_ASSET__DKG68el8__"